import logo from './logo.svg';
import './App.scss';
import { mapKey, mapSecretKey } from './Global';
import dataJson from './data.json';
import request from './components/custom/request';
import React, { useState, useEffect } from 'react';
import ReactPlayer from 'react-player'
import AMapLoader from '@amap/amap-jsapi-loader';

import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from 'react-query'

import Timer from './components/Timer';
import MonitorMenu from './components/Monitor';
import Meteorological from './components/Meteorological';
import VR from './components/VR';

//window.global._AMap;
//window.global.map;
let defaultZoom;
let defaultCenter;


function App() {

  let [choose, setChoose] = useState('');
  const [chooseDeviceIndex, setChooseDeviceIndex] = useState(-1);
  const _setChoose = (key, index = -1) => {
    setChoose(key);
    setChooseDeviceIndex(index);
  }

  let [keyframes, setKeyframes] = useState(['', '', '', '', '', '']);

  //多边形中心点
  const getCenterPoint = (AMap, data) => {
    let lng = 0.0; let lat = 0.0;
    for (let i = 0; i < data.length; i++) {
      lng = lng + parseFloat(data[i].lng);
      lat = lat + parseFloat(data[i].lat);
    }
    lng = lng / data.length;
    lat = lat / data.length;
    return new AMap.LngLat(lng, lat);
  }

  let [mapok, setMapok] = useState(false);

  useEffect(() => {

    window._AMapSecurityConfig = { securityJsCode: mapSecretKey };
    AMapLoader.load({
      key: mapKey,                 // 申请好的Web端开发者Key，首次调用 load 时必填
      version: "2.0",              // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      plugins: ['AMap.Geocoder'],

    }).then((AMap) => {
      window.global._AMap = AMap;
      var geocoder = new AMap.Geocoder({
        // city 指定进行编码查询的城市，支持传入城市名、adcode 和 citycode
        city: '乐山'
      })
      geocoder.getLocation('井研县', function (status, result) {
        if (status === 'complete' && result.info === 'OK') {
          //console.log('result', result)
          let { lng, lat } = result.geocodes[0].location;

          defaultZoom = 11;
          defaultCenter = [lng, lat];
          window.global.map = new AMap.Map("container", { //设置地图容器id
            mapStyle: 'amap://styles/blue', //设置地图的显示样式
            //viewMode: "3D",         //是否为3D地图模式
            zoom: defaultZoom,                //初始化地图级别
            center: defaultCenter, //初始化地图中心点位置
            features: ['bg', 'road', 'building'],
            zooms: [11, 13]
          });

          //console.log('dataJson.features', dataJson)
          dataJson.features.forEach(item => {
            //console.log(item.type)
            let geometry = item.geometry
            if (geometry.type === 'Polygon') {
              let path = [];
              geometry.coordinates[0].forEach(coordinate => {
                path.push(new AMap.LngLat(coordinate[0], coordinate[1]));
              })
              //console.log('fill', item.properties['fill'])
              let polygonArg = {
                path: path,
                fillColor: item.properties['fill'], // 多边形填充颜色
                fillOpacity: item.properties['fill-opacity'],
                borderWeight: item.properties['stroke-width'],
                strokeColor: item.properties['stroke'],
                strokeOpacity: item.properties['stroke-opacity'],
              };
              let polygon = new AMap.Polygon(polygonArg);
              window.global.map.add(polygon);


              let pathCenter = getCenterPoint(AMap, path)
              // 创建纯文本标记
              if (item.properties['name'].length > 0) {
                var text = new AMap.Text({
                  text: item.properties['name'],
                  anchor: 'center', // 设置文本标记锚点
                  style: {
                    'background-color': 'transparent',
                    'cursor': 'default',
                    'border': 'none',
                    'font-size': '15px',
                    'color': '#FFF',
                    'z-index': 999,
                  },
                  position: [pathCenter.lng, pathCenter.lat]
                });
                text.setMap(window.global.map);
              }
            }
          })


          setMapok(true);
        }
      })

    }).catch(e => {
      console.log(e);
    })
  }, []);


  const reLocation = () => {
    //重新定位中心点
    try {
      //console.log('map', map)
      window.global.map.setZoomAndCenter(defaultZoom, defaultCenter, false, 200);
    } catch { }
  }

  //console.log('App')
  return (
    <div className="App">
      <div id="container" className="map" style={{ width: '100%', height: '100vh' }} >
      </div>
      <div className='HeadCenter'>
        <div className='title'>井研县农情数据监测平台</div>
      </div>
      <div className='Head'>
        {/* <div className='title'>物联网监控中心</div> */}
        {/* <div className='kong'></div> */}
        <div className='time'><Timer key={'timer'} /></div>
      </div>
      <div className='Left'>
        {mapok &&
          <>
            <VR />

            <MonitorMenu key={'Monitor'} ckey={'Monitor'} choose={choose} setChoose={_setChoose} chooseDeviceIndex={chooseDeviceIndex} setChooseDeviceIndex={setChooseDeviceIndex} />

            <Meteorological key={'Meteorological'} ckey={'Meteorological'} choose={choose} setChoose={_setChoose} chooseDeviceIndex={chooseDeviceIndex} setChooseDeviceIndex={setChooseDeviceIndex} />
          </>
        }


        <a className='menu' style={{ opacity: 1 }} href='https://sc.web.x37b.cc/b' target='_blank'>
          <div className='iconDiv'>
            <svg t="1716107820336" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1705" width="200" height="200"><path d="M835.2 158.4h-64c0 35.2-28.8 64-64 64s-64-28.8-64-64h-64c0 35.2-28.8 64-64 64s-64-28.8-64-64h-64c0 35.2-28.8 64-64 64s-64-28.8-64-64h-64c0 35.2-28.8 64-64 64v64c38.4 0 72-17.6 96-43.2 24 27.2 57.6 43.2 96 43.2s72-17.6 96-43.2c24 27.2 57.6 43.2 96 43.2s72-17.6 96-43.2c24 27.2 57.6 43.2 96 43.2s72-17.6 96-43.2c24 27.2 57.6 43.2 96 43.2v-64c-35.2 0-64-27.2-64-64zM859.2 424l-104 116.8-94.4-105.6-24-11.2H243.2l-22.4 8-96 96 44.8 44.8 86.4-86.4h368l89.6 100.8-99.2 110.4H254.4l-83.2-88L124.8 656l92.8 97.6 22.4 9.6h105.6l112 104 22.4 8h120l32-32v-81.6l20.8-9.6 102.4-115.2 104 116.8 56-20.8v-288l-56-20.8zM568 811.2h-75.2L448 769.6h120v41.6z m283.2-163.2l-52.8-59.2 52.8-59.2v118.4z" p-id="1706"></path><path d="M246.608 600.48l36.208-36.208 36.208 36.208-36.208 36.192z" p-id="1707"></path></svg>
          </div>
          <div className='count'>
            1/1
          </div>
          <div className='line'>
            <div className='line_right' time='6' style={{ width: '100%', }}>
            </div>
          </div>
          <div className='text'>水产养殖</div>
        </a>


        <div className='menu' style={{ opacity: 0.5 }}>
          <div className='iconDiv'>
            <svg t="1653530864474" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1605" width="200" height="200"><path d="M873.599936 0.00008a90.255993 90.255993 0 0 0-60.263995 22.991998A90.255993 90.255993 0 0 0 753.063946 0.00008h-90.399993v89.999993c0 49.623996 40.559997 89.999993 90.399993 89.999993H783.199944v121.99999H692.799951v179.999986H602.399958v-59.999995h-60.263996V0.00008h-60.271995v421.999967H421.599972v59.999995H331.199979v-179.999986H240.799986V180.000066h30.135998c49.839996 0 90.399993-40.375997 90.399992-89.999993V0.00008h-90.399992a90.255993 90.255993 0 0 0-60.271996 22.991998A90.255993 90.255993 0 0 0 150.399993 0.00008H60v89.999993C60 139.624069 100.559997 180.000066 150.399993 180.000066h30.135998v121.99999h-90.399993v419.999968c0 66.167995 54.071996 119.999991 120.52799 119.99999 66.463995 0 120.535991-53.831996 120.535991-119.99999v-179.999986h90.399993v59.999995h60.263995v361.999972h-180.799986v59.999995h421.871967v-59.999995h-180.799986V602.000033H602.399958v-59.999995h90.399993v179.999986c0 66.167995 54.071996 119.999991 120.53599 119.99999 66.455995 0 120.527991-53.831996 120.527991-119.99999v-419.999968h-90.399993V180.000066h30.135997c49.839996 0 90.399993-40.375997 90.399993-89.999993V0.00008h-90.399993zM240.799986 90.000073c0-16.543999 13.519999-29.999998 30.135998-29.999998h30.127997v29.999998c0 16.543999-13.519999 29.999998-30.127997 29.999998H240.799986v-29.999998zM150.399993 120.000071c-16.615999 0-30.135998-13.455999-30.135998-29.999998V60.000075H150.399993c16.615999 0 30.135998 13.455999 30.135998 29.999998V120.000071H150.399993z m120.535991 601.999953c0 33.079997-27.039998 59.999995-60.271996 59.999995s-60.263995-26.919998-60.263995-59.999995v-179.999986h120.535991v179.999986z m0-239.999982H150.399993v-119.99999h120.535991v119.99999z m271.199978 59.999996h-60.271995v-59.999996h60.271995v59.999996zM753.063946 120.000071c-16.615999 0-30.127998-13.455999-30.127998-29.999998V60.000075h30.127998c16.615999 0 30.135998 13.455999 30.135998 29.999998V120.000071h-30.135998zM873.599936 722.000024c0 33.079997-27.039998 59.999995-60.263995 59.999995-33.231997 0-60.271995-26.919998-60.271995-59.999995v-179.999986H873.599936v179.999986z m0-359.999972v119.99999H753.063946v-119.99999H873.599936z m30.135998-271.999979c0 16.543999-13.519999 29.999998-30.135998 29.999998h-30.135997v-29.999998c0-16.543999 13.519999-29.999998 30.135997-29.999998h30.135998v29.999998z" p-id="1606"></path></svg>
          </div>
          <div className='count'>
            0/0
          </div>
          <div className='line'>
            <div className='line_right' time='6' style={{ width: '0%', }}>
            </div>
          </div>
          <div className='text'>水质检测</div>
        </div>

        <div className='menu' style={{ opacity: 0.5 }}>
          <div className='iconDiv'>
            <svg t="1653531013384" className="icon" viewBox="0 0 1092 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1883" width="200" height="200"><path d="M994.133333 832c25.506133 0 49.809067-9.813333 68.437334-27.613867 19.1488-18.304 29.696-42.5984 29.696-68.386133V640h-98.133334c-24.576 0-47.0016 9.2928-64 24.5248A95.607467 95.607467 0 0 0 866.133333 640H770.133333v96c0 52.932267 43.067733 96 96 96h32v128h-320v-128h32c52.932267 0 96-43.067733 96-96V640H610.133333c-24.576 0-47.0016 9.2928-64 24.5248A95.607467 95.607467 0 0 0 482.133333 640H386.133333v96c0 52.932267 43.067733 96 96 96h32v128h-320v-128h32c52.932267 0 96-43.067733 96-96V640H226.133333c-24.576 0-47.0016 9.2928-64 24.5248A95.607467 95.607467 0 0 0 98.133333 640H0v96c0 25.787733 10.5472 50.082133 29.696 68.386133C48.3328 822.1952 72.635733 832 98.133333 832h32v128H0v64h1092.266667v-64h-130.133334v-128h32z m-32-96a32.034133 32.034133 0 0 1 32-32h34.133334v32c0 17.0496-15.957333 32-34.133334 32h-32v-32z m-384 0a32.034133 32.034133 0 0 1 32-32h32v32A32.034133 32.034133 0 0 1 610.133333 768h-32v-32z m-384 0a32.034133 32.034133 0 0 1 32-32h32v32A32.034133 32.034133 0 0 1 226.133333 768h-32v-32zM130.133333 768H98.133333c-18.176 0-34.133333-14.9504-34.133333-32V704h34.133333a32.034133 32.034133 0 0 1 32 32V768z m384 0H482.133333a32.034133 32.034133 0 0 1-32-32V704h32a32.034133 32.034133 0 0 1 32 32V768z m384 0h-32a32.034133 32.034133 0 0 1-32-32V704h32a32.034133 32.034133 0 0 1 32 32V768zM1092.266667 64H770.133333v67.217067c72.942933 14.8736 128 79.5136 128 156.782933v32h-704v-32c0-77.269333 55.057067-141.909333 128-156.782933V64H0V0h1092.266667v64z m-706.133334 0V128h320V64h-320zM828.6464 256c-13.201067-37.248-48.7936-64-90.513067-64h-384c-41.719467 0-77.312 26.752-90.513066 64h565.026133zM322.133333 384h64v128h-64V384z m128 0h64v128h-64V384z m128 0h64v128h-64V384z m128 0h64v128h-64V384z" p-id="1884"></path></svg>
          </div>
          <div className='count'>
            0/0
          </div>
          <div className='line'>
            <div className='line_right' time='6' style={{ width: '0%', }}>
            </div>
          </div>
          <div className='text'>杀虫灯</div>
        </div>

        <a className='menu' style={{ opacity: 1 }} href='https://jy.cs.x37b.cc/bd' target='_blank'>
          <div className='iconDiv'>
            <svg t="1733387644478" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5263" width="200" height="200"><path d="M868.929504 871.603133c0 26.736292-21.389034 48.125326-48.125326 48.125327H200.522193c-26.736292 0-48.125326-21.389034-48.125326-48.125327v-114.966057H90.903394v114.966057c0 61.493473 48.125326 109.618799 109.618799 109.618799h620.281985c61.493473 0 109.618799-48.125326 109.618799-109.618799v-114.966057h-61.493473v114.966057zM152.396867 155.070496c0-26.736292 21.389034-48.125326 48.125326-48.125326h620.281985c26.736292 0 48.125326 21.389034 48.125326 48.125326v114.966058h61.493473V155.070496c0-61.493473-48.125326-109.618799-109.618799-109.618799H200.522193c-61.493473 0-109.618799 48.125326-109.618799 109.618799v114.966058h61.493473V155.070496z m77.535248 556.114883c53.472585-203.195822 82.882507-307.467363 85.556136-312.814622 0-5.347258 2.673629-13.368146 2.673629-26.736292 0 13.368146 2.673629 21.389034 2.673629 29.409921 2.673629 5.347258 32.083551 109.618799 82.882507 310.140993h64.167101l106.94517-401.044387h-64.167102c-45.451697 200.522193-66.840731 307.467363-66.840731 312.814622 0 5.347258-2.673629 16.041775-5.347258 29.409921h-2.673629c-2.673629-16.041775-2.673629-29.409922-5.347259-34.75718-2.673629-10.694517-32.083551-112.292428-80.208877-307.467363h-66.840731c-45.451697 160.417755-69.51436 259.342037-80.208878 299.446475-2.673629 10.694517-5.347258 21.389034-10.694517 37.43081h-2.673629c-2.673629-18.715405-5.347258-32.083551-5.347258-34.75718-5.347258-37.430809-29.409922-139.028721-66.840731-299.446476H53.472585l106.94517 401.044387h69.51436z m564.13577-352.91906c53.472585 2.673629 90.903394 29.409922 106.94517 82.882506l61.493472-16.041775c-29.409922-77.535248-82.882507-114.966057-165.765013-120.313316-117.639687 5.347258-181.806789 77.535248-189.827676 208.543081 5.347258 128.334204 66.840731 197.848564 184.480418 203.195822 96.250653 0 152.396867-45.451697 173.785901-131.007833l-61.493473-16.041775c-13.368146 66.840731-50.798956 98.924282-112.292428 104.27154-77.535248-5.347258-117.639687-58.819843-122.986945-157.744125 8.020888-101.597911 50.798956-152.396867 125.660574-157.744125z" p-id="5264"></path></svg>
          </div>
          <div className='count'>
            online
          </div>
          <div className='line'>
            <div className='line_right' time='6' style={{ width: '100%', }}>
            </div>
          </div>
          <div className='text'>厕所文化</div>
        </a>

      </div>


      <div className='Location'>
        <div onClick={reLocation}>
          <svg t="1653625062784" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4893"  ><path d="M87.424 469.312A426.816 426.816 0 0 1 469.312 87.424V0h85.376v87.424a426.816 426.816 0 0 1 381.888 381.888H1024v85.376h-87.424a426.816 426.816 0 0 1-381.888 381.888V1024h-85.376v-87.424A426.816 426.816 0 0 1 87.424 554.688H0v-85.376h87.424z m424.576 384a341.312 341.312 0 1 0 0-682.624 341.312 341.312 0 0 0 0 682.624z m0-170.624a170.688 170.688 0 1 0 0-341.376 170.688 170.688 0 0 0 0 341.376z" p-id="4894"></path></svg>
        </div>
      </div>
    </div >
  );

}


export default App;
